import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges, NgZone } from '@angular/core';
import { IKeyValueInterface, BookingStatus } from './../../shared/config';
import { Router } from "@angular/router";
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL } from '../../shared/config';
import { DirectDebitFileXML } from "../models/direct-debit-file.model";
import { InvoiceService } from "../models/invoice.service";
import { FlatPickrModel } from "../../plugins/flatpickr/flatpickr.model";
import { FlatPickrDirective } from "../../plugins/flatpickr/flatpickr.directive";

const moment = require("moment");

@Component({
  selector: 'create-directdebit-file-popup',
  template: require('../views/create-directdebit-file-popup.component.html'),
  providers: [InvoiceService],
})

export class CreateDirectDebitFilePopupComponent implements OnInit {
  apiErrorMsg: any;
  _model: DirectDebitFileXML[];
  _companyDDModel: DirectDebitFileXML[];
  _isDirectDebitClick: boolean;
  formatList: any;

  @ViewChild('flatPickrConfigDate') public flatPickrConfigDate: FlatPickrDirective;

  public isLoading: boolean;
  public headers: any;
  public errorModel: IKeyValueInterface[];
  public errorMsg: string;
  public selectedCompany: any;
  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_FORMAT;
  flatPickrConfigFrom: FlatPickrModel;
  public collectionDate: string = "";
  public selectedCompanyid: string;
  public popupMsg: string;
  public format: string;
  public isFormatChange: boolean;

  @ViewChild('successPopup') public successPopup: any;
  @ViewChild('createDirectDebitModel') public createDirectDebitModel: any;
  @ViewChild('directDebitCollectionDateModel') public directDebitCollectionDateModel: any;
  @Output('OnSuccessSave') onSuccessSave = new EventEmitter();
  @Output('OnFormatChange') onFormatChange = new EventEmitter();

  constructor(private authService: AuthService
    , private router: Router
    , private translate: TranslateService
    , private zone: NgZone
    , private invoiceService: InvoiceService
  ) {

  }

  @Input()
  set model(_directDebitFileList: DirectDebitFileXML[]) {
    this._model = _directDebitFileList;

    this.InitCompanyArray();

    if (!this.isFormatChange || this.isDirectDebitClick) {
      this.format = '';
      this.selectedCompany = new DirectDebitFileXML();
      
      let newDate = moment(this.selectedCompany.minCollectionDate, "DD-MM-YYYY").toDate();

      this.flatPickrConfigFrom.minDate = newDate;
      this.collectionDate = this.selectedCompany.minCollectionDate;
      if (this.flatPickrConfigDate) {
        this.flatPickrConfigDate.ChangeValue(this.collectionDate);
      }
    }
  }
  get model() { return this._model; }


  @Input()
  set companyDDModel(_directDebitFileList: DirectDebitFileXML[]) {

    if (!this.isFormatChange || this.isDirectDebitClick)
      this._companyDDModel = _directDebitFileList;
  }
  get companyDDModel() {
    return this._companyDDModel;
  }

  @Input()
  set isDirectDebitClick(_IsDirectDebitClick: boolean) {
    this._isDirectDebitClick = _IsDirectDebitClick;
  }
  get isDirectDebitClick() {
    return this._isDirectDebitClick;
  }


  ngOnInit() {
    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
    this.formatList = [
      {
        Key: '',
        Value: 'Select'
      },
      {
        Key: 'Default',
        Value: 'Rabobank'
      },
      {
        Key: 'ABN',
        Value: 'ABN Amro Bank'
      }];
  }

  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = false;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;
    flatPickrConfig.disable = [(date: any) => {
      return (date.getDay() === 0 || date.getDay() === 6);
    }];

    return flatPickrConfig;
  }

  public show(): void {
    this.errorMsg = '';
    this.errorModel = [];

    this.createDirectDebitModel.show();
  }

  public hide(): void {
    this.createDirectDebitModel.hide();
    this.companyDDModel = null;
    this.model = null;
    this.onSuccessSave.emit({ SuccessMessage: "" })
  }

  private hideModel() {
    this.hide();
  }

  public SelectFile(event: Event) {
    if (this.format) {
      this.selectedCompany = this.model.find(x => x.id == this.selectedCompanyid);
    }
  }

  public OnFormatChange(event: Event) {
    this.isFormatChange = true;
    this.onFormatChange.emit({ format: this.format });
  }

  public OnExport() {
    if (this.collectionDate) {
      this.errorMsg = "";
      this.invoiceService.DownloadDirectDebitFile(this.selectedCompany.invoiceId, this.collectionDate, this.format).subscribe(
        (res: any) => {
          if (res && res._body) {
            let fileName = "directDebitFile" + new Date().toISOString() + ".xml";
            this.authService.DownloadFile(fileName, res._body);
            this.popupMsg = this.translate.instant('LblDirectDebitDownloadSuccess');
            this.successPopup.show();

            if (this.model.length == 1) {
              this.createDirectDebitModel.hide();
              this.onSuccessSave.emit({ SuccessMessage: "" })
            } else {
              this._companyDDModel = this.companyDDModel.filter(x => x.id != this.selectedCompanyid);
              this.model = this.model.filter(x => x.id != this.selectedCompanyid);
              if (this.model.length == 0) {
                this.createDirectDebitModel.hide();
                this.onSuccessSave.emit({ SuccessMessage: "" })
              }
              this.selectedCompanyid = this.selectedCompany.id;
            }
          }
          this.isLoading = false;
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        });
    } else {
      this.errorMsg = this.translate.instant('LblPleaseEnterCollectionDate');;
    }
  }

  private InitCompanyArray() {

    if (this.format) {
      this.selectedCompany = this.model[0];
    } else {
      this.selectedCompany = new DirectDebitFileXML();

    }

    if (!this.isFormatChange || this.isDirectDebitClick) {
      if (this.selectedCompany.id) {
        this.selectedCompanyid = this.selectedCompany.id;
      } else if (this.companyDDModel.length > 0) {
        this.selectedCompanyid = this.companyDDModel[0].id;
      }
    }
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/invoice/components/create-directdebit-file-popup.component.ts